<template>
  <ui-modal
    :show="showVideo"
    type="tag"
    title="视频播放"
    @close="showVideo = false"
  >
    <!-- <xdvideo-player
      :auth="auth"
      :vid="vid"
      :controls="true"
      :loop="false"
      :muted="false"
      :autoplay="true"
    ></xdvideo-player> -->
  </ui-modal>
</template>

<script>
import { mapState } from "vuex";
import UiModal from "@/components/ui-modal.vue";

export default {
  name: "StarVideo",
  components: {
    UiModal,
  },
  data() {
    return {
      showVideo: false,
      vid: "",
    };
  },
  computed: {
    ...mapState({
      auth: (state) => state.xdvideo.auth,
    }),
  },
  methods: {
    play(vid) {
      this.vid = vid;
      this.showVideo = true;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.modal__cover {
  .modal__container {
    background: none;
    max-height: unset;
    .modal__inner {
      .modal__header {
        .title {
          opacity: 0;
        }
      }
      .modal__body {
        border-radius: 0 !important;
      }
    }
  }
}
</style>